function getLanguage(locale: string) {
    return split(locale)[0];
}

function getRegion(locale: string) {
    return split(locale)[1];
}

function split(locale: string) {
    return locale.split(/[-_]/);
}

export const Locale = {
    getLanguage,
    getRegion,
};
